import "./table-content.component.scoped.sass";
import React, { useEffect } from "react";
import { TableHeaderComponent } from "../table-header/table-header.component";
import { TableContentProps } from "../../types/table-content-props";
import { TableRowComponent } from "../table-row/table-row.component";
import { TableFooterComponent } from "../table-footer/table-footer.component";
import { tableHeightSetter } from "src/helpers";

export const TableContentComponent = (props: TableContentProps) => {
  const { options, columns, data, tools, paginate, pagination, loading, title, clickableRow } = props;
  useEffect(() => {
    tableHeightSetter();
    window.onresize = function() {
      tableHeightSetter();
    };
  }, [loading, data])
  
  return (
    <div>
      <div className="ov">
        <TableHeaderComponent columns={columns} options={options} tools={tools} />
        <div className="table-content">
          {data.map((row: any, index: number) => {
            return (
              ((row.tasks && row.tasks.length) || !row.tasks) && (
                <TableRowComponent key={index} data={row} columns={columns} title={title} clickableRow={clickableRow}/>
              )
            );
          })}
        </div>
      </div>
      <TableFooterComponent paginate={paginate} pagination={pagination}/>
    </div>

  );
};
